import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import Grade from './Grade'
import { useParams } from "react-router-dom"
import {useGetTaskGradesQuery} from '../responses/responsesApiSlice'
import { useGetActionsQuery } from "../actions/actionsApiSlice"
import { useState } from "react"
const GradesList = () => {
    const {groupId, taskId} = useParams()
    const [codeSearch, setCodeSearch] = useState("")
    const [userFilter, setUserFilter] = useState("")
    useTitle('geshtop-Exercise: Grades List')
    const {
        data: responses,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetTaskGradesQuery({taskId},'gradeList')
    const{
        data:actions,
        isLoading : actionsLoading,
        isSuccess:actionsSuccess

    } = useGetActionsQuery('actionsList')
    let content

    if (isLoading || actionsLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess && actionsSuccess ) {
       
        //console.log(responses)
        const temResponse = responses.map(response=>{
            const newResponse = {...response}
            newResponse.responseCombinedText = JSON.stringify(response.body).toLowerCase() + JSON.stringify(response.additions)?.toLowerCase()
            return newResponse
        })
        const filterResponse =temResponse.filter(response=>{
            return (
                (codeSearch==='' || response.responseCombinedText.indexOf(codeSearch) > -1) &&
                (userFilter==='' || (response.fullname.indexOf(userFilter) > -1 || response.username.indexOf(userFilter) > -1) )
            )
        })
        const tableContent = filterResponse.map((response, inx) => <Grade inx={inx} key={response._id} actions={actions} response={response} />)

        content = (
            <>
              <div className="filter-form wrap">
           <h2>תרגילים לפי משימה</h2>
           <div className="filter-form-item">
                <input  placeholder="חיפוש פנימי לפי ביצוע" className="form__input sm" onChange={(e)=>setCodeSearch(e.target.value)} />
            </div>
           <div className="filter-form-item">
                <input placeholder="חיפוש פנימי לפי משתמש" className="form__input sm" onChange={(e)=>setUserFilter(e.target.value)} />
            </div>
            </div>
          
            <table className="table table--admin-grades">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th admin-grades--user__username">Username</th>
                        <th scope="col" className="table__th admin-grades--user__name">שם</th>
                        <th scope="col" className="table__th admin-grades--user__name">קבוצה</th>
                        <th scope="col" className="table__th admin-grades--user__name">משימה</th>
                        <th scope="col" className="table__th admin-grades--user__email">הערות</th>
                        {/* <th scope="col" className="table__th user__phone">הוגש בתאריך</th> */}
                        <th scope="col" className="table__th admin-grades--user__groups">ציון</th>                      
                        {/* <th scope="col" className="table__th user__roles">ע"י</th> */}
                        <th scope="col" className="table__th admin-grades--user__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent }
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default GradesList